<style lang="scss">
  @use "../../../assets/css/design-system/colors";
  @use "../../../assets/css/design-system/utils";
  @use "../../../assets/css/design-system/mixins";

  p {
    padding: utils.in_rem(24px);
    @include mixins.body1();
  }

  $margin-left-right: utils.in_rem(24px);

  .footer {
    width: calc(100% - 2 * $margin-left-right);
    display: flex;
    justify-content: flex-end;
    padding: utils.in_rem(12px) 0;
    gap: utils.in_rem(16px);
    margin: 0 $margin-left-right;
    border-top: 1px solid colors.get(interfaceSwGrey_10);
  }
</style>

<script>
  import Button from "../../atoms/Button.svelte";
  import Modal from "./Modal.svelte";

  export let confirmText = "Confirm";
  export let confirmKind = "primary";
  export let cancelText = "Cancel";
  export let confirm = () => {};
  export let cancel = () => {};
  export let blur = "4px";
</script>

<Modal onclose={cancel} {blur} closeButton={false}>
  <slot name="header" slot="header" />
  <p class="body">
    <slot />
  </p>
  <div class="footer">
    <Button class="flex-1" onclick={cancel} kind="ghost-blue">
      {cancelText}
    </Button>
    <Button class="flex-1" onclick={confirm} kind={confirmKind}>
      {confirmText}
    </Button>
  </div>
</Modal>
